import {AppContext} from '../../../../app-context';
import {exportDataAsExcel} from '../../../../common/upload/excel.utils';
import moment from 'moment';

export interface LocationRefdataAuditRow {
    organisationId: string;
    organisationName: string;
    locationId: string;
    locationName: string;
    address: string;
    cadastreId: string;
    displayedEnergyLabel: string;
    officialEnergyLabel: string;
    registrationDate: string;
    validUntil: string;
    lookupStatus: string;
    lastAttemptAt: string;
    lastCheckedAt: string;
    buildYear: string;
    area: number;
    buildingType: string;
}

const labels = {
    en: {
        headers: ['Organisation', 'Location', 'Address', 'Location ID', 'BAG addressable object ID',
            'Displayed energy label', 'Official EP-Online label', 'Registration date',
            'Valid until', 'EP-Online status', 'Last attempt', 'Last successful check', 'Building year',
            'Area (m²)', 'Building type'],
        fileName: 'location-reference-data-audit',
        statuses: {
            PENDING: 'Not checked', FOUND: 'Found', NOT_FOUND: 'Not found', UNAVAILABLE: 'Previous result unknown',
            CONFIGURATION_ERROR: 'Configuration error', AUTHENTICATION_FAILED: 'Authentication failed',
            INVALID_RESPONSE: 'Invalid response', NETWORK_ERROR: 'Connection failed'
        }
    },
    nl: {
        headers: ['Organisatie', 'Locatie', 'Adres', 'Locatie-ID', 'BAG verblijfsobject-ID',
            'Getoond energielabel', 'Officieel EP-Online-label', 'Registratiedatum',
            'Geldig tot', 'EP-Online-status', 'Laatste poging', 'Laatste succesvolle controle', 'Bouwjaar',
            'Oppervlakte (m²)', 'Gebouwtype'],
        fileName: 'audit-locatiereferentiedata',
        statuses: {
            PENDING: 'Niet gecontroleerd', FOUND: 'Gevonden', NOT_FOUND: 'Niet gevonden',
            UNAVAILABLE: 'Vorige uitkomst onbekend', CONFIGURATION_ERROR: 'Configuratiefout',
            AUTHENTICATION_FAILED: 'Authenticatie mislukt', INVALID_RESPONSE: 'Ongeldig antwoord',
            NETWORK_ERROR: 'Verbinding mislukt'
        }
    }
};

export function locationRefdataAuditRows(rows: LocationRefdataAuditRow[], language = 'en'): any[][] {
    const locale = language === 'nl' ? labels.nl : labels.en;
    return [locale.headers, ...rows.map(row => [
        row.organisationName, row.locationName, row.address, row.locationId, row.cadastreId,
        row.displayedEnergyLabel, row.officialEnergyLabel,
        asDate(row.registrationDate), asDate(row.validUntil),
        locale.statuses[row.lookupStatus] || row.lookupStatus,
        asDate(row.lastAttemptAt), asDate(row.lastCheckedAt), row.buildYear, row.area, row.buildingType
    ])];
}

export function downloadLocationRefdataAudit(rows: LocationRefdataAuditRow[]): void {
    const language = AppContext.getPreferredLanguage() === 'nl' ? 'nl' : 'en';
    const locale = labels[language];
    exportDataAsExcel(locationRefdataAuditRows(rows, language),
        `${locale.fileName}-${moment().format('YYYY-MM-DD')}.xlsx`);
}

function asDate(value: string): Date | null {
    return value ? new Date(value) : null;
}
